import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environment.ts/environment';

export interface LeadData {
  id_site: number;
  email: string;
  produit: string;
  status: string;
  source: string;
  type: string;
  notes: string;
}

export interface ClientData {
  id_site: number;
  prospect_id: number;
  payment_status: 'PENDING' | 'SUCCESS' | 'FAILED';
  transaction: {
    reference: string;
    montant_ht: number;
    montant_ttc: number;
    moyen_paiement: string;
    paymentIntent: string;
  };
  card: {
    cardToken: string;
    cardHolder: string;
    cardLast4: string;
    cardExpiry: string;
    cardType: string;
  };
  product: string;
}

export interface SubscriptionData {
  id_site: number;
  id_client: number;
  origine: string;
  id_abonnement_payment_method: string;
  id_transaction: string,
  id_produit: number,
  abonneData: {
    email: string;
  };
}

export interface PaymentMethodData {
  customer_id: string;
  client_id: number;
  payment_gateway: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProcessApiService {
  private readonly apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  /**
   * Crée un nouveau Prospect
   * @returns Observable<any> - La réponse de l'API
   */
  createProspect(email: string, produit: string): Observable<any> {
    const prospectData = {
        id_site: 6,
        email: email,
        firstName: '-',
        lastName: '-',
        telephone: '-',
        ip_utilisateur: '-', // À implémenter si nécessaire
        marque: 'pdf-to-word.fr',
        produit: produit,
        numero_geolocaliser: '-',
        // Ajouter les informations de carte
        card: {
            cardToken: '-',
            cardHolder: '-',
            cardLast4: '-',
            cardExpiry: '-',
            cardType: '-'
        }
      };
    return this.http.post(`${this.apiBaseUrl}${environment.apiEndpoints.prospects.create}`, prospectData);
  }

  /**
   * Crée un nouveau Lead
   * @returns Observable<any> - La réponse de l'API
   */
  createLead(email: string, produit: string): Observable<any> {
    const leadData: LeadData = {
      id_site: 6,
      email: email,
      produit: produit,
      status: 'prospect',
      source: 'pdf-to-word.fr',
      type: 'Conversion de fichier',
      notes: 'Conversion de fichier PDF to WORD'
    };

    return this.http.post(`${this.apiBaseUrl}${environment.apiEndpoints.leads.create}`, leadData);
  }

  /**
   * Crée un nouveau Client
   * @param clientData - Les données du client à créer
   * @returns Observable<any> - La réponse de l'API
   */
  createClient(clientData: ClientData): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/clients`, clientData);
  }

  /**
   * Crée un nouvel Abonnement
   * @param subscriptionData - Les données de l'abonnement à créer
   * @returns Observable<any> - La réponse de l'API
   */
  createSubscription(subscriptionData: SubscriptionData): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/subscriptions`, subscriptionData);
  }

  /**
   * Crée un nouvel Payment Method Local
   * @param paymentMethodData - Les données du payment method à créer
   * @returns Observable<any> - La réponse de l'API
   */
  createPaymentMethod(paymentMethodData: PaymentMethodData): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/payment-methods`, paymentMethodData);
  }
}
